import { useMutation, useQueryClient } from '@tanstack/react-query';
import { VehicleDocumentApi } from 'api';

export function useDeleteVehicleDocument() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-vehicle-document'],
    mutationFn: (id) => VehicleDocumentApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['vehicle-documents']);
      queryClient.invalidateQueries(['document-categories']);
    },
  });
}
